import React from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  label: string;
  isSelected: boolean;
  isAvailable: boolean;
  onClick: (label: string) => void;
}

const Spot = ({ label, isSelected, isAvailable, onClick }: Props) => {
  return (
    <SpotButton
      onClick={() => onClick(label)}
      disabled={!isAvailable}
      isSelected={isSelected}
    >
      {label}
    </SpotButton>
  );
};

interface SpotButtonProps {
  isSelected: boolean;
}

const SpotButton = styled.button<SpotButtonProps>`
  width: 4.5rem;
  padding: 0;
  padding: 0.5rem 0;
  font-family: Poppins-Medium;
  border-radius: 1rem;
  border: none;
  background-color: ${(props) => (props.isSelected ? Colors.red : Colors.aqua)};
  color: white;
  margin: 0.25rem;
  cursor: pointer;
  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export default Spot;
